import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pexceptionhandle(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>

<Helmet>
 
  <title>Learn Free Python Exception Handling Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python exception handling tutorial for beginners.,A program converts successfully but the result is not correct.it means run time error .this type of error handled by exception handling." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,python exception handling,python exception handling example
,python exception handling best practices,python catch exception and continue,python exception catch all,python handle exception and continue,python json loads exception handling,python unittest exception handling,python exception handling tutorial
,python exception handling catch all,python catch exception in thread,python catch exception and print message" />
<link rel="canonical" href="https://www.codeexampler.com/python-exception-handling" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Python exception handling</h1>

    <div className="first">
        <a href="/python-function-overriding">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <p className="mt-4 para">Python exception handling is a condition that occurs due to an error &#38; and an error is a mistake by which a program doesn’t work correctly.</p>
<h2 className="mt-4 mh2">Types of error in Python exception handling:</h2>
<p className="mt-4 para">1, Compile-time error(interpreted time)<br/>
2, This error can occur by the language translator at the time of compilation<br/>
3, A program converts successfully, but the result is not correct. It means run time error .this type of error is handle by exception handling.<br/>
4, We can set up exception handling blocks in our code.<br/>
</p>



<h2 className='headings'>Python Exception Handling Syntax:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">Try</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-1">-</span>
                 {"\n"}
                 <span className="qwerty-1">-</span>
                 {"\n"}
                 <span className="qwerty-1">-</span>
                 <span className="qwerty"> except</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">Exception handling</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>   




<h2 className='headings'>Python Exception Handling Examples:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}             
             <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">input</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter first no</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
             <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">input</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter second no</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty">try</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-8">    c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">/</span>
                 <span className="qwerty-4">b</span>
                 {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Result =</span>
                 <span className="qwerty-5">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-8">%c</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty">except </span>
                 <span className="qwerty-2">ZeroDivisionError</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">can't divided by zero</span>
                 <span className="qwerty-1">")</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">Enter first no </span>
                         <span className="qwerty-3">50</span>
                     {"\n"}
                         <span className="qwerty-2">Enter second no </span>
                         <span className="qwerty-3">0</span>
                     {"\n"}
                         <span className="qwerty-4">can't divided by zero </span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>



<h2 className='headings'>Python Exception Handling Examples:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
                 {"\n"}
                 <span className="qwerty">try</span>
                 <span className="qwerty-1">:</span>
             {"\n"}             
             <span className="qwerty-4">    n</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">input</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter a no</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">You enter </span>
                 <span className="qwerty-5">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-8">%n</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty">except </span>
                 <span className="qwerty-2">ValueError</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">only number input</span>
                 <span className="qwerty-1">")</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">Enter a no </span>
                         <span className="qwerty-3">2.5</span>
                     {"\n"}
                         <span className="qwerty-4">only number input </span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>



<h2 className="mt-4 mh2"> Python exception handling in keyword</h2>
<p className="mt-4 para">Keyword in Python exception handling this statement is final keyword will execute one exception cause or not.</p>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/python-function-overriding">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Pexceptionhandle;